export default "<!-- <router-outlet></router-outlet> -->\n\n<app-scene1></app-scene1>\n";